import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "../seo/setPageMeta";

export default function NotFound() {
  useEffect(() => {
    setPageMeta({
      title: "Page Not Found | Celebrate Recovery Independence KY",
      description: "The page you are looking for could not be found.",
      noindex: true,
    });
  }, []);

  return (
    <section>
      <h2 className="page-title">Page Not Found</h2>
      <p className="page-intro">
        The page you are looking for does not exist or may have been moved.
      </p>
      <div className="button-row">
        <Link to="/" className="btn btn-primary">
          Go Home
        </Link>
      </div>
    </section>
  );
}
